export default {
  running: [],
  has_simulation: true,
  loading: false,
}
